import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "arrow",
  class: "tooltip__arrow",
  "data-popper-arrow": ""
}, null, -1)

import { computed, CSSProperties, onMounted, onUnmounted, ref, watch } from 'vue'
import * as Popper from '@popperjs/core'
import Union from '@/assets/Union.svg'

interface Props {
  referenceElementId: string
  text?: string,
  placement: Popper.Placement
  confirmText?: string,
  isActive: boolean,
  offset?: number,
  width?: number,
  paddingRight?: number,
  isOnboarding?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
    referenceElementId: null,
    text: null,
    placement: null,
    confirmText: null,
    isActive: { type: Boolean },
    offset: { default: 0 },
    width: { default: 224 },
    paddingRight: { default: 30 },
    isOnboarding: { type: Boolean, default: false }
  },
  emits: ["next", "close"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'next'): void
  (event: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { referenceElementId: string, text?: string, placement: Popper.Placement, confirmText?: string, isActive: boolean, offset: number, width: number, paddingRight: number, isOnboarding: boolean };





const popper = ref<Popper.Instance | null>(null)

const nextTooltip = () => {
  popper.value?.destroy()
  emits('next')
}

const closeTooltips = () => {
  emits('close')
}

const tooltipContentStyle = computed<CSSProperties>(() => {
  return {
    width: props.width + 'px',
    paddingRight: props.paddingRight + 'px'
  }
})

const tooltip = ref<HTMLElement | null>(null)
onMounted(() => {
  if (props.isOnboarding) {
    createTooltip()
  }
})

onUnmounted(() => {
  popper.value?.destroy()
})

const createTooltip = () => {
  const elem: HTMLElement | null = document.getElementById(props.referenceElementId)
  if (elem && tooltip.value) {
    popper.value = Popper.createPopper(elem, tooltip.value, {
      placement: props.placement,
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [props.offset, 23] // controls the offset of the tooltip (along the reference, away from the reference)
          }
        },
        {
          name: 'arrow',
          options: {
            padding: 14 // controls how close the arrow can get to the edge of the tooltip
          }
        },
        {
          name: 'preventOverflow',
          options: {
            tetherOffset: 20, // controls how close to the edge of the reference element the tooltip can be
            padding: 14 // controls how far the tooltip is from the edges of the viewport
          }
        }
      ]
    })
  }
}

watch(() => props.isActive, () => {
  if (props.isActive) {
    if (!props.isOnboarding) {
      createTooltip()
    } else {
      tooltip.value?.setAttribute('data-show', 'true')
      popper.value?.update()
    }
  } else {
    tooltip.value?.removeAttribute('data-show')
    popper.value?.destroy()
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "tooltip",
    ref_key: "tooltip",
    ref: tooltip,
    "data-testid": "tooltip"
  }, [
    (__props.isOnboarding)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "tooltip__close-button",
          onClick: closeTooltips,
          "data-testid": "close"
        }, [
          _createVNode(_unref(Union))
        ]))
      : _createCommentVNode("", true),
    (__props.isOnboarding)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "tooltip__content",
          style: _normalizeStyle(_unref(tooltipContentStyle))
        }, [
          (__props.text)
            ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(__props.text), 1))
            : _createCommentVNode("", true),
          (__props.confirmText)
            ? (_openBlock(), _createElementBlock("label", {
                key: 1,
                class: "tooltip__confirm-button",
                onClick: nextTooltip,
                "data-testid": "confirm"
              }, _toDisplayString(__props.confirmText), 1))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    _hoisted_2
  ], 512))
}
}

})